import { createContext } from "react";
import { StoreApi } from "zustand";
import { GatheringPreviewPublicStore } from "../stores/gatheringPreviewPublicStore";

const GatheringPreviewPublicContext = createContext<{
	store: StoreApi<GatheringPreviewPublicStore>;
} | null>(null);

export default GatheringPreviewPublicContext;
